import { render, staticRenderFns } from "./InfoToast.vue?vue&type=template&id=0883823b"
import script from "./InfoToast.vue?vue&type=script&lang=js"
export * from "./InfoToast.vue?vue&type=script&lang=js"
import style0 from "./InfoToast.vue?vue&type=style&index=0&id=0883823b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports